module.exports = __webpack_public_path__ + "img/medical_herba.d61d900f.png";